import React, {useEffect, useRef, useState} from 'react';
import './MainBlock.scss';
import './MainBlock-media.scss';
import Button from '../Button/Button';
import InputPhone from '../Input/InputPhone';
import { ServiceData } from '../../redux/services/ServiceRedux';
import { connect, WithStore, MapStateToProps, MapDispatchToProps } from '../../redux/services/Imports';
import { Props } from './interfaces';
import { MediaContent, ValidationFormItems } from '../../services/GlobalFunctions';
import { EnumUrlsPages } from '../../services/Enum';
import SuccessForm from '../SuccessForm/SuccessForm';
import ErrorTextBlocked from '../ErrorTextBlocked/ErrorTextBlocked';
import { CSSTransition } from 'react-transition-group';
import SliderMainBlock from '../SliderMainBlock/SliderMainBlock';
import LinkBig from '../LinkBig/LinkBig';
import {content} from "../../services/content";
import {createPortal} from "react-dom";
import ModalFormFeedback from "../ModalFormFeedback/ModalFormFeedback";
import {SelectValuesFormSimple} from "../../services/content/Constants";

const MainBlock = ({
  widthWindow,
  blockedSend,
  blockedSendLoaded,
  recaptchaV2ref,
  mainData
}: Props) => {
  const [phone, setPhone] = useState('+7');
  const [serverText, setServerText] = useState<string | null>(null);
  const [successShow, setSuccessShow] = useState(false);
  const [disableBtn, setDisableBtn] = useState(false);
  const [showBlockedError, setShowBlockedError] = useState(false);
  const [showFeedback, setShowFeedback] = useState(false);
  const [blogMain, setBlogMain] = useState([]);

  useEffect(() => {
    // @ts-ignore
    ServiceData.getBlogMain().then(setBlogMain);
  }, []);

  const success = () => {
    setPhone('+7');
    setSuccessShow(true);
    // setTimeout(() => setSuccessShow(false), 3000);
    setDisableBtn(false);
  };

  const ClosedModal = () => setSuccessShow(false);

  const handleReCaptchaVerify = async (e: any) => {
    e.preventDefault();
    setDisableBtn(true);

    setShowBlockedError(false);
    if (blockedSend.state) {
      setShowBlockedError(true);
      setDisableBtn(false);
      return;
    }

    const token = '';

    ServiceData.submitForm({
      data: { name: '', phone },
      setServerText,
      success,
      token,
      blockedSendLoaded,
      eventMetrika: 'form_consult',
    });
  };

  const handleFormSubmit = async(e: any) => {
    e.preventDefault();
    console.log('phone number on submit', phone);
    setShowFeedback(true);
  }

  const nodeRefSuccess = useRef(null);

  return (
    <div className="main-block">
      <CSSTransition
        in={successShow}
        nodeRef={nodeRefSuccess}
        timeout={{ appear: 200, enter: 0, exit: 200 }}
        classNames="css-transition-modal"
        unmountOnExit
      >
        <div className="main-block__success-msg">
          <div className="main-block__success">
            <SuccessForm refCss={nodeRefSuccess} closed={ClosedModal} />
          </div>
        </div>
      </CSSTransition>

      <div className="main-block__info">
        <p className="main-block__text">{mainData.small_title}</p>
        <h1 className="main-block__title">{mainData.title}</h1>

        <div className="main-block__links">
          <Button text={content.mainBlock.buttonDelivery} link={EnumUrlsPages.delivery} type="link" size="M" />
          <Button text={content.mainBlock.buttonIntegration} link={EnumUrlsPages.integration} type="link" size="M" />
          <Button text={content.mainBlock.buttonDeliveryPVZ} link={EnumUrlsPages.deliveryPVZ} type="link" size="M" />
        </div>

        <form className="main-block__consultation" onSubmit={handleFormSubmit}>
          <InputPhone
            label={content.mainBlock.phone}
            name="phone"
            value={phone}
            onChange={(e: any) => setPhone(e.target.value)}
            error={serverText}
          />
          <Button text={content.mainBlock.getProposal} size="M" widthAll={widthWindow < 720} disabled={disableBtn} />

          <p className="main-block__agreement">
            {showBlockedError && blockedSend.state && <ErrorTextBlocked counter={blockedSend.counter} />}
            <noindex>
              {content.formContacts.text1}
              <a href={EnumUrlsPages.policy}>{content.formContacts.privacyPolicy}</a>
              {content.formContacts.text2}
            </noindex>
          </p>
        </form>
      </div>

      {MediaContent(
        <div className="main-block__column2">
          <div className="main-block__slider">
            <SliderMainBlock slides={blogMain} />
          </div>
          <div className="main-block__bg" />
        </div>,
        <>
          <div className="main-block__bg" />
          <SliderMainBlock slides={blogMain} />
        </>
      )}

      <div className="main-block__grid-4">
        <LinkBig text={content.mainBlock.linkTracking} link={EnumUrlsPages.tracking} />
        <LinkBig text={content.mainBlock.linkCalculator} link={EnumUrlsPages.calculator} />
        <LinkBig text={content.mainBlock.linkDeliveryRu} link={EnumUrlsPages.deliveryRu} />
        <LinkBig text={content.mainBlock.linkVacancies} link={EnumUrlsPages.vacancies} />
      </div>
      {createPortal(
        <ModalFormFeedback
          hasCssTransition
          showForm={showFeedback}
          id="feedback"
          title={content.header.textModalFeedback}
          select={{ options: SelectValuesFormSimple }}
          closedModal={() => setShowFeedback(false)}
          phoneNumber={phone}
        />,
        document.body
      )}
    </div>
  );
};

export default WithStore()(connect(MapStateToProps, MapDispatchToProps)(MainBlock));
